export const random = list => list[Math.floor(Math.random() * list.length)]
